var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.9996,
    cy: 50.9996,
    r: 50.4762,
    fill: "#DFEBEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5278_1366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7498 80.9576C40.7426 80.9576 39.7572 80.963 38.7947 80.963C29.9754 80.963 23.2383 80.9427 23.2383 71.2911C23.2383 61.6395 30.6207 53.7163 40.0459 52.8568C40.1218 56.2322 51.2849 64.5648 51.2849 64.5648C51.2849 64.5648 62.4452 56.2322 62.5197 52.8555C71.9463 53.7163 79.3274 62.0706 79.3274 71.2911C79.3274 80.5116 72.5875 80.963 63.7669 80.963C62.8044 80.963 61.8189 80.9576 60.8131 80.9576H41.7498Z",
    fill: "#307F92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.286 55.283C59.8111 55.283 66.7218 42.4635 66.7218 33.9383C66.7218 25.4132 59.8125 18.5039 51.286 18.5039C42.7595 18.5039 35.8516 25.4146 35.8516 33.9383C35.8516 42.4621 42.7622 55.283 51.286 55.283Z",
    fill: "#307F92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5278_1366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.0891,
    height: 62.4643,
    fill: "white",
    transform: "translate(23.2383 18.5039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPerson);
export default __webpack_public_path__ + "static/media/defaultPerson.baba0b86c78f1930f7a3f0afc9eaf7f7.svg";
export { ForwardRef as ReactComponent };